import { Component, inject, signal } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TerminalActionCardComponent } from './components/terminal-action-card/terminal-action-card.component';
import { TerminalActionCardModel } from './models/terminal-action-card.model';
import { RentalAgreementsRecordResolver } from '../../../modules/admin/rental-agreements/rental-agreements-record/rental-agreements-record.resolver';
import { RentalAgreementsRecordComponent } from '../../../modules/admin/rental-agreements/rental-agreements-record/rental-agreements-record.component';
import { take } from 'rxjs';
import { ActiveDarkenDirective } from '../../directives/active-darken.directive';
import { CustomersRecordResolver } from '../../../modules/admin/customers/customers-record/customers-record.resolver';
import { CustomersRecordComponent } from '../../../modules/admin/customers/customers-record/customers-record.component';
import { VehiclesRecordResolver } from '../../../modules/admin/vehicles/vehicles-record/vehicles-record.resolver';
import { VehiclesRecordComponent } from '../../../modules/admin/vehicles/vehicles-record/vehicles-record.component';

@Component({
	selector: 'app-terminal',
	templateUrl: 'terminal.component.html',
	imports: [IonicModule, TerminalActionCardComponent, ActiveDarkenDirective],
})
export class TerminalComponent {
	#rentalAgreementResolver = inject(RentalAgreementsRecordResolver);
	#customerResolver = inject(CustomersRecordResolver);
	#vehicleResolver = inject(VehiclesRecordResolver);
	actions = signal<TerminalActionCardModel[]>([
		{
			svgIcon: 'receipt_long',
			title: 'terminal|action|rental-agreement|title',
			descrption: 'terminal|action|rental-agreement|description',
			onClick: () => {
				this.#rentalAgreementResolver
					.resolve(null, RentalAgreementsRecordComponent, null)
					.pipe(take(1))
					.subscribe();
			},
		},
		{
			svgIcon: 'groups',
			title: 'terminal|action|customer|title',
			descrption: 'terminal|action|customer|description',
			onClick: () => {
				this.#customerResolver
					.resolve(null, CustomersRecordComponent, null)
					.pipe(take(1))
					.subscribe();
			},
		},
		{
			svgIcon: 'directions_car',
			title: 'terminal|action|vehicle|title',
			descrption: 'terminal|action|vehicle|description',
			onClick: () => {
				this.#vehicleResolver
					.resolve(null, VehiclesRecordComponent, null)
					.pipe(take(1))
					.subscribe();
			},
		},
		// {
		// 	title: 'Check out',
		// 	svgIcon: 'arrow_circle_up',
		// 	descrption: 'Give out a vehicle',
		// 	onClick: () => {},
		// },
		// {
		// 	title: 'Check in',
		// 	svgIcon: 'arrow_circle_down',
		// 	descrption: 'Collect a vehicle',
		// 	onClick: () => {},
		// },
	]);
}
